module.exports = __webpack_public_path__ + "@/assets/img/warning-triangle.4b55f908.svg";